import React from 'react'
import { useTranslation } from 'react-i18next'

/** Branded loading skeleton for analysis pages. */
export default function AnalysisPageLoader({
  kpiCount = 2,
  chartCount = 4,
}: {
  kpiCount?: number
  chartCount?: number
}) {
  const { t } = useTranslation()
  return (
    <div className="ma-loader" role="status" aria-live="polite">
      <div className="ma-loader-banner">
        <span className="ma-loader-spinner" aria-hidden />
        <div>
          <p className="ma-loader-title">
            {t('analysis.loading.title', {
              defaultValue: 'Loading analysis…',
            })}
          </p>
          <p className="ma-loader-hint">
            {t('analysis.loading.hint', {
              defaultValue: 'Fetching indicators and charts for this view.',
            })}
          </p>
        </div>
      </div>

      {kpiCount > 0 ? (
        <div
          className={`ma-kpi-grid${kpiCount >= 3 ? ' ma-kpi-grid--3' : ''}`}
        >
          {Array.from({ length: kpiCount }).map((_, i) => (
            <div key={`kpi-${i}`} className="ma-kpi ma-skeleton-card">
              <div className="ma-skeleton ma-skeleton--eyebrow" />
              <div className="ma-skeleton ma-skeleton--value" />
              <div className="ma-skeleton ma-skeleton--bar" />
              <div className="ma-skeleton ma-skeleton--line" />
            </div>
          ))}
        </div>
      ) : null}

      {chartCount > 0 ? (
        <div className="ma-chart-grid">
          {Array.from({ length: chartCount }).map((_, i) => (
            <div key={`chart-${i}`} className="ma-card ma-skeleton-card">
              <div className="ma-card-head">
                <div className="ma-skeleton ma-skeleton--title" />
              </div>
              <div className="ma-card-body ma-card-body--chart">
                <div className="ma-skeleton ma-skeleton--chart" />
              </div>
            </div>
          ))}
        </div>
      ) : null}
    </div>
  )
}
